<template>
    <VStepperStep v-bind="$attrs" v-on="$listeners">
        <slot />
    </VStepperStep>
</template>

<script>
export default {
    name: 'WrapperVStepperStep',
    mounted() {
        this.$children[0].click = (event) => {
            const thisContext = this.$children[0];
            thisContext.$emit('click', event);

            if (thisContext.editable) {
                thisContext.stepClick(thisContext.step);
            }
        };
    },
};
</script>
